export default "* Opskyl\n* Skaller\n* Affald";